// import React, { useState } from "react";
// import { Sheet, SheetTrigger, SheetContent } from "./components/Landing/components/ui/sheet";
// import { Button } from "./components/Landing/components/ui/button";

// export default function App() {
//   const [open, setOpen] = useState(false);

//   return (
//     <div>
//       <Sheet open={open} onOpenChange={setOpen}>
//         <SheetTrigger>
//           <Button onClick={() => setOpen(true)}>Open Sheet</Button>
//         </SheetTrigger>
//         <SheetContent side="right">
//           <div style={{ padding: '20px' }}>This is the sheet content</div>
//         </SheetContent>
//       </Sheet>
//     </div>
//   );
// }


// App.jsx
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";

const App = () => {
  return (
    <Router>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
    </Router>
  );
};

export default App;





// import React from "react";
// import Toggle from "./components/toogle/toogle";

// const App = () => {
//   const handleToggleChange = (id, value) => {
//     console.log(`Toggle ${id} is now: ${value}`);
//   };

//   return (
//     <div style={{ padding: "2rem" }}>
//       <h2>Reusable Toggle Demo</h2>
//       <Toggle
//         label="Notifications"
//         defaultOn={true}
//         onChange={(value) => handleToggleChange("notifications", value)}
//       />
//       <Toggle
//         label="Dark Mode"
//         defaultOn={false}
//         onChange={(value) => handleToggleChange("darkMode", value)}
//       />
//       <Toggle
//         label="Auto Updates"
//         defaultOn={false}
//         onChange={(value) => handleToggleChange("autoUpdates", value)}
//       />
//     </div>
//   );
// };

// export default App;

// // App.jsx
// import React, { useState, useEffect } from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   useLocation,
// } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import "./App.css";
// import Header from "./components/H&F/Header.jsx";
// import Footer from "./components/H&F/Footer.jsx";
// import Login from "./components/Login/Login.jsx";
// import Forgot from "./components/Login/Forgot.jsx";
// import Support from "./Pages/Support.jsx";
// import Ticketdashboard from "./Pages/Ticketdashboard.jsx";
// import Ticketrise from "./Pages/Ticketrise.jsx";
// import Ticketassign from "./components/Chat&assign/Ticketassign.jsx";
// import Report from "./components/Menu/Report.jsx";
// import Shift from "./components/Menu/Shift.jsx";
// import Landing from "./components/Landing/components/Landing.jsx";

// // ─── ProtectedRoute Component ────────────────────────────────────────────────
// const ProtectedRoute = ({ children }) => {
//   const location = useLocation();
//   const user = JSON.parse(localStorage.getItem("userdetails"));

//   localStorage.setItem("manualLogout", "true");

//   const manualLogout = localStorage.getItem("manualLogout") === "true";
//   if (!user) {
//     if (!manualLogout) {
//       alert("Session expired or not logged in. Redirecting to login.");
//     }
//     localStorage.removeItem("manualLogout"); // clear the flag
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// const App = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const location = useLocation();

//   // keep header button in sync
//   useEffect(() => {
//     const user = localStorage.getItem("userdetails");
//     setIsLoggedIn(!!user);
//   }, []);

//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const status = params.get("status");

//     if (status === "success") {
//       alert("User signup successfully");
//       window.history.replaceState(null, "", window.location.pathname);
//     } else if (status === "exists") {
//       alert("User already exists");
//       window.history.replaceState(null, "", window.location.pathname);
//     }
//   }, []);

//   return (
//     <div className="app">
//       <Router>

//         {location.pathname !== "/" && (
//           <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
//         )}

//         <main className="main-content">
//           <Routes>
//             {/* public */}
//             {/* <Route path="/" element={<Login />} /> */}
//             <Route path="/" element={<Landing />} />
//             <Route path="/Forgot" element={<Forgot />} />

//             {/* protected */}
//             <Route
//               path="/CA"
//               element={
//                 <ProtectedRoute>
//                   <Ticketassign />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/CM"
//               element={
//                 <ProtectedRoute>
//                   <Ticketdashboard />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/CU"
//               element={
//                 <ProtectedRoute>
//                   <Ticketrise />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/SU"
//               element={
//                 <ProtectedRoute>
//                   <Support />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/reports"
//               element={
//                 <ProtectedRoute>
//                   <Report />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/shiftschedule"
//               element={
//                 <ProtectedRoute>
//                   <Shift />
//                 </ProtectedRoute>
//               }
//             />
//           </Routes>
//         </main>

//         {location.pathname !== "/" && <Footer />}
//       </Router>

//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//       />
//     </div>
//   );
// };

// export default App;

// import React from 'react';
// import './components/Landing/components/app.css';
// // import Header from './Header';
// // import HeroSection from './HeroSection';
// // import ServicesSection from './ServicesSection';
// // import WhyChooseUsSection from './WhyChooseUsSection';
// // import HowItWorksSection from './HowItWorksSection';
// // import AboutSection from './AboutSection';
// // import ContactSection from './ContactSection';
// // import Footer from './Footer';
// import Header from './components/Landing/components/Header.jsx';
// import HeroSection from './components/Landing/components/HeroSection.jsx';
// import ServicesSection from './components/Landing/components/ServicesSection.jsx';
// import WhyChooseUsSection from './components/Landing/components/WhyChooseUsSection.jsx';
// import HowItWorksSection from './components/Landing/components/HowItWorksSection.jsx';
// import AboutSection from './components/Landing/components/AboutSection.jsx';
// import ContactSection from './components/Landing/components/ContactSection.jsx';
// import Footer from './components/Landing/components/Footer.jsx';

// function App() {
//   return (
//     <div className="App">
//       <Header />
//       <HeroSection />
//       <ServicesSection />
//       <WhyChooseUsSection />
//       <HowItWorksSection />
//       <AboutSection />
//       <ContactSection />
//       <Footer />
//     </div>
//   );
// }

// export default App;
